// 頂部列的常用平台膠囊：一鍵切換最常用的平台；已選取的其他平台也會出現在這裡，方便取消。
import type { PlatformKey } from '@dayone/core/dictionaries';
import { type FilterState, togglePlatform } from '../../filters/state.ts';
import type { Update } from '../../filters/useFilterState.ts';
import { t } from '../../i18n/zh-TW.ts';
import { PlatformIcon } from '../../ui/icons/PlatformIcon.tsx';

export const QUICK_PLATFORMS: readonly PlatformKey[] = ['pc', 'ps5', 'switch2'];

export function QuickPlatforms({ state, update }: { state: FilterState; update: (u: Update) => void }) {
  const list = [...QUICK_PLATFORMS, ...state.platforms.filter((p) => !QUICK_PLATFORMS.includes(p))];
  return (
    <fieldset className="quick-platforms">
      <legend className="sr-only">{t.nav.quickPlatforms}</legend>
      {list.map((p) => {
        const on = state.platforms.includes(p);
        return (
          <button
            key={p}
            type="button"
            className={on ? 'pill pill-on' : 'pill'}
            aria-pressed={on}
            onClick={() => update((s) => ({ ...s, platforms: togglePlatform(s.platforms, p), page: 1 }))}
          >
            <PlatformIcon platform={p} />
            {t.platforms[p]}
          </button>
        );
      })}
    </fieldset>
  );
}
